import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordCount',
})
export class WordCountPipe implements PipeTransform {
  transform(html: string): number {
    if (!html) {
      return 0;
    }

    // Parse HTML
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || '';

    // Remove punctuation: ! ? . , - ; :
    const cleanText = text.replace(/[!?.,\-;:]/g, '');

    // Split by whitespace and count words
    const words = cleanText.trim().split(/\s+/).filter(Boolean);

    return words.length;
  }
}
